import { createSelector } from 'reselect'
import { createMatchSelector } from 'connected-react-router/immutable'
import { getIn } from 'utils/immutable'
import qs from 'qs'
import { propOr } from 'ramda'
import {
  vehiclesId,
  referenceParametersRPNumRelease,
  vehiclesEcus,
  featuresId,
} from 'constants/routes'
import { SNAPSHOTS_URI } from 'constants/featureSnapshots'

const getRouter = (state) => state.get('router')

export const getPathname = createSelector(getRouter, (router) =>
  router.getIn(['location', 'pathname'])
)

const getLocationSearch = getIn(['router', 'location', 'search'])

export const getIsEditRoute = createSelector(getLocationSearch, (search) => {
  const queryParams = qs.parse(search, { ignoreQueryPrefix: true })
  return JSON.parse(propOr(null, 'editing', queryParams))
})

export const getHistoryQueryParams = createSelector(
  getLocationSearch,
  (search) => {
    const queryParams = qs.parse(search, { ignoreQueryPrefix: true })
    const id = propOr(null, 'history', queryParams)

    return id && `${SNAPSHOTS_URI}/${id}`
  }
)

export const getIsHistoryRoute = createSelector(
  getHistoryQueryParams,
  (searchParams) => !!searchParams
)

export const getVehicleRouteMatch = createMatchSelector({ path: vehiclesId })
export const getEcusRouteMatch = createMatchSelector({ path: vehiclesEcus })

export const getRPRouteMatch = createMatchSelector({
  path: referenceParametersRPNumRelease,
})

export const getFeaturesRouteMatch = createMatchSelector({ path: featuresId })
